$(function () {

    const selectArr = document.querySelectorAll('.product_select div');

    if (selectArr.length > 0) {
        for (let i = 0; i < selectArr.length; i++) {
            selectArr[i].addEventListener('click', (e => {
                e.preventDefault();
                for (let p = 0; p < selectArr.length; p++) {
                    if (selectArr[p].classList.contains('is-checked')) {
                        selectArr[p].classList.remove('is-checked');
                    }
                }
                selectArr[i].classList.add('is-checked');
                let variantId = $(selectArr[i]).data("variant-id")
                $("input#variant_id").val(variantId)
            }))
        }
    }


    const productCountInput = document.querySelector('.product_count--value');
    const productCountDecrement = document.querySelector('.product_count--decrement');
    const productCountIncrement = document.querySelector('.product_count--increment');
    let productCountValue = 1;

    if (productCountIncrement) {
        productCountIncrement.addEventListener('click', e => {
            e.preventDefault();
            productCountValue = incrementFunc(productCountInput, productCountValue);
        })
    }

    if (productCountDecrement) {
        productCountDecrement.addEventListener('click', e => {
            e.preventDefault();
            productCountValue = decrementFunc(productCountInput, productCountValue);
        })
    }

    const incrementFunc = (item, value) => {
        value++;
        item.value = value;
        return value
    }

    const decrementFunc = (item, value) => {
        if (value >= 2) {
            value--;
            item.value = value;
        } else {
            value = 1;
            item.value = value;
        }
        return value
    }

    const addProductBtn = document.querySelectorAll('.products .primary_btn');
    if (addProductBtn.length > 0) {
        for (let i = 0; i < addProductBtn.length; i++) {
            addProductBtn[i].addEventListener('click', (e => {
                e.preventDefault();
                addProductBtn[i].classList.add('added');
            }))
        }
    }


    //Create reviews
    const stickyReviewsArr = document.querySelectorAll('.ps_reviews--sticky .reviews_item')
    const stickyReviewsBox = document.querySelector('.ps_reviews--sticky .reviews_box')
    const reviewsPaginationBox = document.querySelector('.reviews_pagination')
    const reviewsPaginationList = document.querySelector('.reviews_pagination--list')

    const itemsPerPage = 4
    const countPages = Math.ceil(stickyReviewsArr.length / itemsPerPage)

    let currentPageIndex = 0

    const createPagesNumber = (index) => {
        let listDiv = document.createElement('div')
        listDiv.innerHTML = `${index + 1}`
        if (index === 0) {
            listDiv.classList.add('active')
        }
        reviewsPaginationList.appendChild(listDiv)
    }

    const createWrapDiv = (index, prevStep, nextStep) => {
        let reviewsBox = document.createElement('div')
        reviewsBox.classList.add('reviews_box--wrap')

        for (let p = prevStep; p < nextStep; p++) {
            reviewsBox.appendChild(stickyReviewsArr[p].cloneNode(true))
            stickyReviewsArr[p].remove()
        }
        if (index === 0) {
            reviewsBox.classList.add('active')
        }
        stickyReviewsBox.appendChild(reviewsBox)
    }

    const removeActiveClass = (arr) => {
        for (let i = 0; i < arr.length; i++) {
            arr[i].classList.remove('active')
        }
    }

    if (stickyReviewsArr.length > 0) {
        reviewsPaginationBox.classList.add('active')
        let step = itemsPerPage
        let prevStep = 0

        for (let i = 0; i < countPages; i++) {
            createPagesNumber(i)
            createWrapDiv(i, prevStep, step)
            prevStep = step
            step + itemsPerPage > stickyReviewsArr.length ? step = stickyReviewsArr.length : step += itemsPerPage
        }

        const pagDivs = document.querySelectorAll('.reviews_pagination--list div');
        const reviewsDivs = document.querySelectorAll('.reviews_box--wrap');

        for (let i = 0; i < pagDivs.length; i++) {
            pagDivs[i].addEventListener('click', event => {
                event.preventDefault();
                currentPageIndex = i
                removeActiveClass(pagDivs)
                removeActiveClass(reviewsDivs)
                pagDivs[i].classList.add('active')
                reviewsDivs[i].classList.add('active')
            })
        }
    }

});